import { Trans } from "@lingui/react/macro";
import React, { useState } from "react";

import { ApiConnector, RequestError } from "../api/api-connector";
import { Button } from "../components/ui-kit/button";
import { Dialog } from "../components/ui-kit/dialog";
import { useDialog } from "../components/ui-kit/dialog-provider";
import { PasswordInput } from "../components/ui-kit/fields/password-input";
import { Form } from "../components/ui-kit/form/form";

export function PasswordPrompt({ api }: { api: ApiConnector }) {
  const [password, setPassword] = useState("");
  const { alert } = useDialog();

  return (
    <Dialog open>
      <Form
        onSubmit={async () => {
          try {
            await api.relogin(password);
          } catch (error) {
            if (
              error instanceof RequestError &&
              error.response.status === 401
            ) {
              setPassword("");
              await alert(JSON.stringify(error.data));
            } else {
              throw error;
            }
          }
        }}
      >
        <div className="flex flex-col">
          <div className="mb-2">
            <Trans>Please confirm with your password.</Trans>
          </div>

          <PasswordInput
            autofocus
            value={password}
            onChange={(newValue) => {
              setPassword(newValue);
            }}
          />

          <div className="h-2" />

          <div className="flex justify-end gap-2">
            <Button
              onClick={() => {
                api.cancelPasswordPrompt();
              }}
            >
              <Trans>Cancel</Trans>
            </Button>

            <Button type="submit">
              <Trans>Confirm</Trans>
            </Button>
          </div>
        </div>
      </Form>
    </Dialog>
  );
}
